import React from 'react';
import { Icon } from 'semantic-ui-react';
import './SideBar.css';
function SideBar({ refs }){

    const menuList = [
        { name: 'About', iconName: 'home', ref: refs.aboutRef },
        { name: 'Education', iconName: 'book', ref: refs.educationRef },
        { name: 'Skills', iconName: 'code', ref: refs.skillsRef },
        { name: 'Blog', iconName: 'blogger b', ref: refs.blogRef },
        { name: 'Contact', iconName: 'whatsapp square', ref: refs.contactRef },
    ];

    const handleScroll = (sectionRef) => {
        if (sectionRef.current) {
          sectionRef.current.scrollIntoView({
            behavior: 'smooth',
          });
        }
      };

    return (
        <div className="sidebar">
           
            {
                menuList.map((item, index) => {
                    return (
                        <div className='menuIteam' onClick={() => handleScroll(item.ref)}>
                            <Icon name={item.iconName} />
                            <div>{item.name}</div>
                        </div>
                        
                    )
                })
            }
            <div id='wrap'>
            <a href='https://dummybucket20.s3.ap-south-1.amazonaws.com/Karthikeyan+(1).pdf' className='btn-slide' download='https://dummybucket20.s3.ap-south-1.amazonaws.com/Karthikeyan+(1).pdf'>
            <span className='circle'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M13 12H16L12 16L8 12H11V8H13V12ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z" fill="white"></path></svg>
            </span>
            <span className="title">Download CV</span>
            <span className='title-hover'>Click Here</span>
            </a>
            </div>
        </div>
    )
}

export default SideBar;